import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import { FullPageLoader } from "@/components/Loader";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Feed from "@/pages/Feed";
import Discover from "@/pages/Discover";
import Profile from "@/pages/Profile";
import EditProfile from "@/pages/EditProfile";
import Reels from "@/pages/Reels";
import Jobs from "@/pages/Jobs";
import Messages from "@/pages/Messages";
import Pricing from "@/pages/Pricing";
import Admin from "@/pages/Admin";
import About from "@/pages/About";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullPageLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/about" element={<About />} />
            <Route element={<AppShell />}>
              <Route path="/feed" element={<Protected><Feed /></Protected>} />
              <Route path="/discover" element={<Discover />} />
              <Route path="/reels" element={<Reels />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/messages" element={<Protected><Messages /></Protected>} />
              <Route path="/messages/:otherId" element={<Protected><Messages /></Protected>} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/profile/:id" element={<Profile />} />
              <Route path="/settings" element={<Protected><EditProfile /></Protected>} />
              <Route path="/admin" element={<Admin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
